export default __webpack_public_path__ + "static/media/carciofoTtsIt_It60.9f217c0a.mp3";